export default __webpack_public_path__ + "static/media/552.6865211e.png";